import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Tabs, Tab, Box } from '@mui/material';
import Field from 'core/oms/Field';
import FieldView from 'core/components/layout/FieldView';
import ProductInfoImpl from './ProductInfoImpl';
import ShowProformaInvoice from 'components/product/components/price-calculation/ShowProformaInvoice';
import ProductInfo from 'components/wkf/components/ProductInfo';
import CommentMgmt from 'components/wkf/components/comment/CommentMgmt';
import { callGetAPI } from 'api/ApiUtils';
import { setCommentList } from 'store/slice/AppSlice';

export default function ViewproductDetails() {
  const dispatch = useDispatch();
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const [tabIndex, setTabIndex] = useState(0);
  const { mobileView } = useSelector((state) => state.menu);

  useEffect(() => {
    console.log("Fetching comments for productObj:", productObj);
    if (!productObj) return;
    callGetAPI("https://api.platform.appmachine.in/comments/boid/" + productObj.id + "/boobjid", () => { },
      (response) => {
        dispatch(setCommentList(response));
      }, (error) => {
        console.error("Error fetching comments", error);
      }
    );
  }, [productObj]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: '8px',
          height: '8px'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1',
          borderRadius: '4px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#c1c1c1',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: '#a8a8a8'
          }
        }
      }}
    >
      <Grid
        container
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: '100%',
          minHeight: '100%',
        }}
      >
        {!mobileView &&
          <Grid item lg={8} md={8} sm={12} xs={12} sx={{ pr: 1 }}>
            <ShowProformaInvoice productObj={productObj} pdfViewerHeight="80vh" />
          </Grid>
        }
        <Grid item lg={4} md={4} sm={4} xs={12}>
          <Box sx={{ borderRadius: 2, minHeight: '70vh', p: 0 }}>
            <Tabs
              value={tabIndex}
              onChange={(_, v) => setTabIndex(v)}
              variant="fullWidth"
              sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab label="Product" />
              <Tab label="Comments" />
              {mobileView && <Tab label="Invoice" />}
            </Tabs>
            <Box sx={{}}>
              {tabIndex === 0 && ProductInfo && (
                <ProductInfo maxHeight={mobileView ? "75vh" : "70vh"} productObj={productObj} />
              )}
              {tabIndex === 1 && (
                <Box sx={{}}>
                  <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                    <CommentMgmt maxHeight="65vh" status={1} />
                  </Box>
                </Box>
              )}
              {tabIndex === 2 && (
                <Grid item lg={8} md={8} sm={12} xs={12} sx={{ pr: 1 }}>
                  <ShowProformaInvoice productObj={productObj} pdfViewerHeight="40vh" />
                </Grid>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}